import { useLandingContent } from "@/lib/landing/LandingContentProvider";
export default function LandingQuestions() {
  const { content } = useLandingContent();
  return (
    <section
      aria-labelledby="questions-title"
      className="bg-landing-page py-14 sm:py-24"
    >
      <div className="landing-container max-w-[860px]">
        <p className="landing-eyebrow">{content.questions.eyebrow}</p>
        <h2 id="questions-title" className="landing-section-title mt-3">
          {content.questions.title}
        </h2>
        <div className="mt-8 space-y-3.5">
          {content.questions.items.map(({ q, a }, i) => (
            <article
              key={i}
              className="rounded-xl border border-landing-question-border bg-landing-panel px-[26px] py-[22px]"
            >
              <h3 className="font-display text-[18.5px] font-semibold">{q}</h3>
              <p className="mt-2 text-base leading-[1.6] text-landing-answer">
                {a}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
